import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const heroImages = [
  'https://public.readdy.ai/ai/img_res/0a8a21bd688e2583ff9ec1eee548f273.jpg',
  'https://readdy.ai/api/search-image?query=high-speed%20motorsport%20racing%20car%20on%20professional%20track%20with%20motion%20blur%20and%20dramatic%20action%20shot%20adrenaline-filled%20moment%20with%20vibrant%20colors%20and%20dynamic%20composition%20professional%20sports%20photography&width=1920&height=1080&seq=hero2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=successful%20corporate%20team%20celebration%20at%20elegant%20business%20event%20with%20emotional%20moments%20people%20networking%20and%20celebrating%20achievements%20in%20modern%20sophisticated%20venue%20with%20warm%20lighting&width=1920&height=1080&seq=hero3&orientation=landscape',
];

export default function Hero() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Background Images with Animation */}
      <AnimatePresence mode="wait">
        <motion.div
          key={currentImage}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0"
        >
          <div className="w-full h-full">
            <img
              src={heroImages[currentImage]}
              alt="Big Finance Eventi"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </motion.div>
      </AnimatePresence>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center px-4">
        <div className="w-full max-w-5xl text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 tracking-wide leading-tight">
              CREIAMO ESPERIENZE<br />CHE LASCIANO IL SEGNO
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex items-center justify-center gap-3 mb-10 text-white/90 text-base md:text-lg font-light"
          >
            <span>Eventi</span>
            <span className="w-2 h-2 rounded-full bg-primary"></span>
            <span>Marketing</span>
            <span className="w-2 h-2 rounded-full bg-primary"></span>
            <span>Motorsport di livello mondiale</span>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <button
              onClick={() => scrollToSection('servizi')}
              className="bg-primary text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-primary/90 transition-all flex items-center gap-2 whitespace-nowrap"
            >
              SCOPRI I NOSTRI SERVIZI
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-sm hover:bg-white hover:text-dark transition-all flex items-center gap-2 whitespace-nowrap"
            >
              CONTATTACI
              <i className="ri-mail-line"></i>
            </button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2 cursor-pointer"
          onClick={() => scrollToSection('chi-siamo')}
        >
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </motion.div>
      </motion.div>

      {/* Image Indicators */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 z-10 flex gap-2">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentImage ? 'bg-primary w-8' : 'bg-white/50'
            }`}
            aria-label={`Vai all'immagine ${index + 1}`}
          ></button>
        ))}
      </div>
    </section>
  );
}